import * as Tabs from "@radix-ui/react-tabs";
import { styled } from "../stitches.config";

export const TabRoot = Tabs.Root;

export const TabContent = styled(Tabs.Content, {
  "&:focus": {
    outline: "none",
  },
});

export const TabList = Tabs.List;

export const TabTrigger = styled(Tabs.Trigger, {
  // button style reset
  border: "none",
  width: "auto",
  overflow: "visible",
  font: "inherit",
  lineHeight: "normal",
  ["-webkit-font-smoothing"]: "inherit",
  ["-moz-osx-font-smoothing"]: "inherit",
  ["-webkit-appearance"]: "none",

  margin: "$1",
  padding: "$buttonPadding $2",
  background: "transparent",
  color: "$paper10",
  borderRadius: "$2",
  cursor: "pointer",
  fontSize: "$4",
  display: "inline-flex",
  placeContent: "center",
  fontFamily: "$default",
  "&:hover": {
    background: "$transparentBlack05",
  },
  "&[data-state=active]": {
    background: "$transparentBlack05",
    fontWeight: "500",
  },
});
